import { Http } from './http.init'
import { ResponseWrapper, ErrorWrapper } from './util'

export class BaseService {
  static get entity () {
    throw new Error('entity getter not defined')
  }
  static get name () {
    throw new Error('name getter not defined')
  }
  static get profile () {
    const profile = window.localStorage.getItem("perfil");
    return profile;
  }
  static get isDatatable () {
    return false
  }
  /**
   * ------------------------------
   * @HELPERS
   * ------------------------------
   */

  static request (status = { auth: true }) {
    return new Http(status)
  }

  static responseWrapper (...rest) {
    return new ResponseWrapper(...rest)
  }

  static errorWrapper (...rest) {
    return new ErrorWrapper(...rest)
  }

  /**
   * ----------------------------
   * BASIC API CALLS
   * ----------------------------
   */

  static async getAll (page=1) {
    try {
      const response = await this.request().get(`${this.profile}/${this.entity}?page=${page}`)
      const data = this.isDatatable ? response.data.data : response.data[this.name];
      return new ResponseWrapper(response, data)
    } catch (error) {
      throw new ErrorWrapper(error)
      // return;
    }
  }

  static async getById (id) {
    try {
      const response = await this.request().get(`${this.profile}/${this.entity}/${id}`)
      const data = response.data[this.name];
      return new ResponseWrapper(response, data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  static async create (data = {}, config = {}) {
    try {
      console.log('post');
      const response = await this.request().post(`${this.profile}/${this.entity}`, data, config)
      return new ResponseWrapper(response, response.data[this.name])
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  static async update (id, data = {},config={}) {
    try {
      const response = await this.request().put(`${this.profile}/${this.entity}/${id}`, data,config)
      return new ResponseWrapper(response, response.data[this.name])
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  static async remove (id) {
    try {
      const response = await this.request().delete(`${this.profile}/${this.entity}/${id}`)
      return new ResponseWrapper(response, response.data[this.name])
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  static async getTrash (page=1) {
    try {
      const response = await this.request().delete(`${this.profile}/${this.entity}/trash?page=${page}`)
      return new ResponseWrapper(response, response.data[this.name])
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  static async restore (id) {
    try {
      const response = await this.request().delete(`${this.profile}/${this.entity}/activate/${id}`)
      return new ResponseWrapper(response, response.data[this.name])
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

}